export const CULTURE_PREFERENCE = 'culture_preference';
export const CULTURE_PREFERENCE_CHOICES = 'choices';
export const CULTURE_PREFERENCE_TYPE = 'type';
export const CULTURE_PREFERENCE_SCORE = 'score';

export const DEFAULT_CULTURE_PREFERENCE_VALUE = {
  [CULTURE_PREFERENCE_CHOICES]: [],
  [CULTURE_PREFERENCE_TYPE]: '',
  [CULTURE_PREFERENCE_SCORE]: 0,
};
